document.addEventListener("DOMContentLoaded", function() {
    var links = document.querySelectorAll("[data-href]");

    for (let i = 0; i < links.length; i++) {
        links[i].addEventListener('click', function () {
            window.location.href = this.dataset.href;

            return false;
        });
    }
});
